import { PageHero, Container, WhySection, GallerySection, DarkCTA } from "@/components/Sections";
import { Reveal } from "@/components/Reveal";
import { Partners } from "@/components/Partners";
import { IMAGES } from "@/data/site";

const BLOCKS = [
  { title: "La nostra azienda", text: "AXAL Logistics è una realtà strutturata specializzata in trasporti, spedizioni e traslochi. Un'organizzazione, non un semplice trasportatore." },
  { title: "La nostra flotta", text: "Mezzi propri di diverse dimensioni, costantemente manutenuti, per gestire ogni tipologia di trasporto in sicurezza e nei tempi previsti." },
  { title: "Come lavoriamo", text: "Programmazione, coordinamento e assistenza dedicata prima, durante e dopo ogni servizio. La qualità è nel metodo." },
];

export default function Azienda() {
  return (
    <>
      <PageHero overline="Azienda" title="AXAL Logistics." img={IMAGES.heroFleet}
        subtitle="Soluzioni professionali per trasporti, spedizioni e traslochi. Un'organizzazione affidabile con mezzi propri e copertura nazionale." />
      <section className="py-24 md:py-32" data-testid="azienda-blocks">
        <Container>
          <div className="grid md:grid-cols-3 gap-8">
            {BLOCKS.map((b, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div className="h-full">
                  <span className="font-head text-6xl font-extrabold text-zinc-100">0{i + 1}</span>
                  <h3 className="font-head text-2xl font-bold mt-2">{b.title}</h3>
                  <p className="text-zinc-500 mt-3 leading-relaxed text-[15px]">{b.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
      <Partners />
      <GallerySection />
      <WhySection />
      <DarkCTA />
    </>
  );
}
